import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuditService } from "../services/audit.service";
import { HttpErrorResponse } from '@angular/common/http';

import { Page } from '../classes/page';
import { ToastService } from '../toast/toast.service';
import { AbstractControl, FormBuilder, FormGroup, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AuthService } from '../services/auth/auth.service';
import { AllotService } from '../services/Allot.service';

@Component({
  templateUrl: './audit.component.html',
})
// Declare Properties
export class AuditComponent implements OnInit {
  @ViewChild('auditorForm') auditorForm!: NgForm;
  page = new Page();
  rows: any[] = []; // All data from API
  filteredRows: any[] = []; // Data displayed after filtering
  loading = false;
  columns: any[] = [];
  filter: any = { district: '', auditortype: '', keyword: '' };
  id: number | null = null;
  dropdownData: any | null = null;
  district: string = '';
  District: string = '';
  auditortype: string = '';
  category: string = '';
  auditorType: string = '';
  auditors: any[] = []; // All auditors for dropdown
  MasterData: any[] = [];
  // filteredAuditors: any[] = [];  // This might not be needed
  filteredData: any[] = [];     // This might not be needed
  auditDateForm!: FormGroup;

  newAuditor = {
    roleId: '',
    filecertificateOfPractice: '',
    name: '',
    mobile: '',
    emailID: '',
    categoryID: '',
    certificateOfPractice: '',
    firmRegistrationNo: '',
    totalAuditFY: '',
    detailAudit: '',
    districtId: '',
    headOfficeAddress: '',
    password: ''
  };


  categories: any;
  districts: any[] = [];
  roleid: number = 0;
  userId: number = 0;
  allDataLoaded = false;
  cd: any;

  //Constructor
  constructor(private auditService: AuditService, private allotService: AllotService, private authService: AuthService, private fb: FormBuilder,
    private router: Router, private toastService: ToastService) {
    {
      this.page.pageNumber = 0;
      this.page.pageSize = 10;
      this.page.totalRecords = 0;
    }

    this.auditDateForm = this.fb.group({
      role: ['', Validators.required],
      rolename: [null],
      userId: [null],
      sAuditStartDate: [null],
      sAuditEndDate: [null],
      arAuditStartDate: [null],
      arAuditEndDate: [null],
    }, {
      validators: this.sAuditEndDateValidator()
    });



  }

  ngOnInit(): void {
    this.GetMasterData();
    this.setPage({ offset: 0 });
    this.auditdates();
    this.roleid = this.authService.currentUserValue.roleId;
    this.userId = this.authService.currentUserValue.id;
    this.columns = [
      { prop: 'name', name: 'Name' },
      { prop: 'auditortype', name: 'Auditor' },
      { prop: 'sDistrictName', name: 'District Name' },
      { prop: 'mobile', name: 'Mobile' },
    ];

  }
  //Search Data from Index Table
  search() {
    this.setPage({ offset: 0 });

  }
  resetAuditDetailsForm(): void {
    this.auditDateForm.reset({
      role: '',
      sAuditStartDate: '',
      sAuditEndDate: '',
      arAuditStartDate: '',
      arAuditEndDate: '',
    });

  }
  sAuditEndDateValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const roleCtrl = formGroup.get('role');
      const role = roleCtrl?.value;

      const startCtrl = formGroup.get('sAuditStartDate');
      const endCtrl = formGroup.get('sAuditEndDate');
      const arStartCtrl = formGroup.get('arAuditStartDate');
      const arEndCtrl = formGroup.get('arAuditEndDate');

      let hasError = false;

      if (role === '1') {
        const startDate = startCtrl?.value ? new Date(startCtrl.value) : null;
        const endDate = endCtrl?.value ? new Date(endCtrl.value) : null;
        const arStartDate = arStartCtrl?.value ? new Date(arStartCtrl.value) : null;

        if (startDate && endDate && endDate <= startDate) {
          endCtrl?.setErrors({ ...(endCtrl.errors || {}), sAuditEndBeforeStart: true });
          hasError = true;
        } else if (arStartDate && endDate && endDate >= arStartDate) {
          endCtrl?.setErrors({ ...(endCtrl.errors || {}), sAuditEndAfterARStart: true });
          hasError = true;
        } else {
          if (endCtrl?.errors) {
            const { sAuditEndBeforeStart, sAuditEndAfterARStart, ...otherErrors } = endCtrl.errors;
            endCtrl.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
          }
        }
      }

      if (role === '2') {
        const arStartDate = arStartCtrl?.value ? new Date(arStartCtrl.value) : null;
        const arEndDate = arEndCtrl?.value ? new Date(arEndCtrl.value) : null;

        if (arStartDate && arEndDate && arEndDate <= arStartDate) {
          arEndCtrl?.setErrors({ ...(arEndCtrl.errors || {}), arAuditEndBeforeStart: true });
          hasError = true;
        } else {
          if (arEndCtrl?.errors) {
            const { arAuditEndBeforeStart, ...otherErrors } = arEndCtrl.errors;
            arEndCtrl.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
          }
        }
      }

      return hasError ? { auditDateInvalid: true } : null;
    };
  }


  formatDate(date: Date): string {
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  onRowsPerPageChange() {
    this.page.pageNumber = 0; // Reset to first page when page size changes
    this.setPage({ offset: 0 });// Call your method to load data for the new page size
  }


  //Get Audit List  data
  setPage(pageInfo: any) {

    this.page.pageNumber = pageInfo.offset;
    this.loadAuditorsFromApi();
    this.applyFiltersAndPagination();

  }


  loadAuditorsFromApi() {
    this.loading = true;
    const requestParams = {
      ...this.page,
      filter: {
        district: this.filter.district,
        auditortype: this.filter.auditortype,
        keyword: this.filter.keyword,
      },
    };
    this.auditService.getAllAuditors(requestParams).subscribe({
      next: (response) => {
        this.loading = false;
        if (response.status === 200) {
          this.rows = response.data;
          this.page.totalRecords = response.totalRecords;  // Assuming the API returns totalRecords
          //    this.toastService.showSuccess(response.message);
          this.allDataLoaded = true;
          this.applyFiltersAndPagination();

        } else {
          this.rows = [];
          this.filteredRows = [];
          this.page.totalRecords = 0;
          //   this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.loading = false;
        this.toastService.showError(error.message);
      },
    });
  }

  applyFiltersAndPagination() {
    this.filteredRows = this.rows.filter(item => {
      const districtMatch = !this.filter.district || item.sDistrictName?.toLowerCase().includes(this.filter.district.toLowerCase()); // Adjust property name as needed
      const auditorTypeMatch = !this.filter.auditortype || item.auditortype?.toLowerCase().includes(this.filter.auditortype.toLowerCase()); // Adjust property name as needed
      const keywordMatch = !this.filter.keyword || item.name?.toLowerCase().includes(this.filter.keyword.toLowerCase()) || item.mobile?.includes(this.filter.keyword); //Adjust property name as needed

      return districtMatch && auditorTypeMatch && keywordMatch;
    });

    // Apply pagination
    const start = this.page.pageNumber * this.page.pageSize;
    const end = start + this.page.pageSize;
    this.filteredRows = this.filteredRows.slice(start, end);


  }


  //onChnage Method for DropDown
  onFilterChange(): void {
    this.page.pageNumber = 0; // Reset to the first page
    this.applyFiltersAndPagination();
  }
  //Get DropDown Data
  GetMasterData(): void {
    this.auditService.getDropDownValues().subscribe(
      (response) => {
        if (response.status === 200) {
          this.categories = response.data.categories;
          this.districts = response.data.districts;
          // this.auditors = response.data.auditors;
          this.auditors = response.data.auditors.filter(
            (a: any) => a.id !== 17
          );
          
          // this.toastService.showSuccess(response.message);

        } else {
          //this.toastService.showError(response.message);
        }
      },
      (error) => {
        // this.toastService.showError(error.message);

      }
    );
  }
  fileName: string = '';
  fileExtension: string = '';
  selectedFile: File | null = null;
  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.fileExtension = this.getFileExtension(file.name);

      if (
        this.fileExtension !== 'jpg' &&
        this.fileExtension !== 'jpeg' &&
        this.fileExtension !== 'png' &&
        this.fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );


        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 4) {
        this.toastService.showError(
          'File size should be less then or equal 4 MB'
        );


        return;
      }
      this.selectedFile = event.target.files[0];
      this.convertToBase64(file, 1);
    }
  }
  base64String2: string = '';
  base64String: string = '';
  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (from === 1) {
        this.base64String = reader.result as string;
      }
      if (from === 2) {
        this.base64String2 = reader.result as string;
      }
    };
  }
  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }
  //   //Get View data by Id
  loadAuditors(id: number): void {
    this.auditService.getAuditorDetails(id).subscribe(
      (response: any) => {
        this.filteredData = response.data;
        // this.toastService.showSuccess(response.message);
      },
      (error) => {
        //this.toastService.showError(error.message);
      }
    );
  }

  submitAuditorForm(auditorForm: NgForm) {
    if (auditorForm.valid) {

      this.newAuditor.filecertificateOfPractice = this.fileName;
      this.newAuditor.certificateOfPractice = this.base64String;
      this.auditService.addAuditor(this.newAuditor).subscribe({
        next: (response) => {
          this.toastService.showSuccess('Auditor added successfully');
          auditorForm.resetForm();
          this.setPage({ offset: 0 });
        },
        error: (error) => {
          this.toastService.showError(error.message || 'Failed to add auditor');
        }
      });
    } else {
      this.toastService.showError('Please fill out the form correctly.');
    }
  }



  resetForm(): void {
    this.newAuditor = {
      roleId: '',
      name: '',
      mobile: '',
      emailID: '',
      categoryID: '',
      certificateOfPractice: '',
      filecertificateOfPractice: '',
      firmRegistrationNo: '',
      totalAuditFY: '',
      detailAudit: '',
      districtId: '',
      headOfficeAddress: '',
      password: ''
    };
    if (this.auditorForm) {
      this.auditorForm.resetForm(this.newAuditor);
    }
  }


  //Update the Audit
  updateAudit(id: number): void {
    this.auditService.updateAudit(this.newAuditor, id).subscribe(
      (response) => {
        this.toastService.showSuccess(response.message);
      },
      (error) => {
        this.toastService.showError(error.message);
      }
    );
  }
  //Open delete Model
  openDeleteModal(id: number): void {
    this.id = id;
  }
  //Delete the Audit
  confirmDelete(): void {
    if (this.id !== null) {
      this.auditService.deleteAudit(this.id).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          window.location.reload();
        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    }
  }
  auditData: any;
  auditdates(): void {
    this.allotService.getAuditAssignDate().subscribe(
      (response: any) => {
        this.auditData = response.data;



      },
      (error: { message: string }) => {
        this.toastService.showError(error.message);
      }
    );
  }
  // assignAuditDate() {
  //   const auditDateData = {
  //     sAuditStartDate: this.auditDateForm.value.sAuditStartDate ? this.auditDateForm.value.sAuditStartDate?.trim() : null,
  //     sAuditEndDate: this.auditDateForm.value.sAuditEndDate ? this.auditDateForm.value.sAuditEndDate?.trim() : null,
  //     ARAuditStartDate: this.auditDateForm.value.arAuditStartDate ? this.auditDateForm.value.arAuditStartDate?.trim() : null,
  //     ARAuditEndDate: this.auditDateForm.value.arAuditEndDate ? this.auditDateForm.value.arAuditEndDate?.trim() : null,
  //   };
  //   if (this.auditDateForm.valid) {
  //     this.auditService.assignAuditDate(auditDateData).subscribe(
  //       (response) => {
  //         if (response.status === 200) {
  //           this.toastService.showSuccess(response.message);
  //           this.auditDateForm.reset();
  //         } else {
  //           this.toastService.showError(response.message);
  //         }
  //       },
  //       (error) => {

  //       }
  //     );
  //   } else {

  //     this.toastService.showError('Please fill out the form correctly.');
  //   }
  // }
  assignAuditDate() {
    const formValues = this.auditDateForm.getRawValue();

    //  const getDateValue = (formVal : any, auditDataVal : any) => {
    //   if (formVal) return formVal;
    //   if (auditDataVal) return auditDataVal;
    //   return new Date().toISOString().split('T')[0]; 
    // };

    const auditData = this.auditData && this.auditData.length > 0 ? this.auditData[0] : null;

    const getOrNull = (formVal: any, dbVal: any) => {
      return formVal != null ? formVal : (dbVal != null ? dbVal : null);
    };
    // const getOrKeepPrevious = (formVal : any, dbVal : any) => {
    //   return formVal != null ? formVal : (dbVal != null ? dbVal : null);
    // };

    const auditDateData = {
      sAuditStartDate: getOrNull(formValues.sAuditStartDate, auditData?.sAuditStartDate),
      sAuditEndDate: getOrNull(formValues.sAuditEndDate, auditData?.sAuditEndDate),
      ARAuditStartDate: getOrNull(formValues.arAuditStartDate, auditData?.arAuditStartDate),
      ARAuditEndDate: getOrNull(formValues.arAuditEndDate, auditData?.arAuditEndDate),
      roleid: formValues.roleid,
      userId: formValues.userId
    };


    if (this.auditDateForm.valid) {
      this.auditService.assignAuditDate(auditDateData).subscribe(
        (response) => {
          if (response.status === 200) {
            this.toastService.showSuccess(response.message);
            this.auditDateForm.reset();
          } else {
            this.toastService.showError(response.message);
          }
        },
        (error) => {
          this.toastService.showError("API Error");
        }
      );
    } else {
      this.toastService.showError('Please fill out the form correctly.');
    }
  }




  onRoleChange(event: any): void {
    const currentYear = new Date().getFullYear();
    const aprilFirst = new Date(Date.UTC(currentYear, 3, 1));
    const arStart = new Date(Date.UTC(currentYear, 4, 16));

    if (event.target.value === '1') {
      this.auditDateForm.get('sAuditStartDate')?.enable();
      this.auditDateForm.get('sAuditStartDate')?.setValue(this.formatDate(aprilFirst));
      this.auditDateForm.get('sAuditStartDate')?.disable();
      this.auditDateForm.get('rolename')?.setValue(this.roleid);
      this.auditDateForm.get('userId')?.setValue(this.userId);

      this.auditDateForm.get('sAuditStartDate')?.setValidators([Validators.required]);
      this.auditDateForm.get('sAuditEndDate')?.setValidators([Validators.required]);
      this.auditDateForm.get('arAuditStartDate')?.clearValidators();
      this.auditDateForm.get('arAuditEndDate')?.clearValidators();
    }
    else {
      this.auditDateForm.get('arAuditStartDate')?.enable();
      this.auditDateForm.get('arAuditStartDate')?.setValue(this.formatDate(arStart));
      this.auditDateForm.get('arAuditStartDate')?.disable();
      this.auditDateForm.get('sAuditStartDate')?.enable();
      this.auditDateForm.get('sAuditStartDate')?.setValue(this.formatDate(aprilFirst));
      this.auditDateForm.get('sAuditStartDate')?.disable();
      this.auditDateForm.get('rolename')?.setValue(this.roleid);
      this.auditDateForm.get('userId')?.setValue(this.userId);
      this.auditDateForm.get('arAuditStartDate')?.setValidators([Validators.required]);
      this.auditDateForm.get('arAuditEndDate')?.setValidators([Validators.required]);


      this.auditDateForm.get('sAuditStartDate')?.clearValidators();
      this.auditDateForm.get('sAuditEndDate')?.clearValidators();



    }

    this.auditDateForm.get('arAuditStartDate')?.updateValueAndValidity();
    this.auditDateForm.get('arAuditEndDate')?.updateValueAndValidity();

    this.auditDateForm.get('sAuditStartDate')?.updateValueAndValidity();
    this.auditDateForm.get('sAuditEndDate')?.updateValueAndValidity();
  }

}



